module.exports = __webpack_public_path__ + "img/menu-button-wide.2df6e37c.svg";